import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { periodColumnDefinition } from '../../shared/columnDefinitions';
import columnDefinitions from '../../shared/columnDefinitions/glAccountsListPage';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

export default ({
  entities,
  periodName,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => xlsxExport({
  sheetData: [
    {
      columnDefinitions: [
        periodColumnDefinition,
        ...columnDefinitions,
      ],
      name: 'BSM GL Account List',
      type: SheetExportTypes.GRID,
      data: entities,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
  ],
  metadata: {
    fileName: `TLS_Balance_Sheet_Management_GL_Account_List_${periodName}${environmentSuffix}`,
  },
});
